module.exports = __webpack_public_path__ + "img/placeholder_public_events.b82977cf.png";